import { Route, Routes } from "react-router-dom";
import SmsLogListScreen from "screens/App/CRM/SMSLogList/SmsLogListScreen";

import { NotFoundScreen } from "screens/NotFoundScreen";

const SmsLogListRouter = () => {
  return (
    <Routes>
      <Route path="list" element={<SmsLogListScreen />} />

      <Route path="*" element={<NotFoundScreen />} />
    </Routes>
  );
};

export default SmsLogListRouter;
